const tabReducer = (state = "app", action) => {
    switch (action.type) {
        case "setActiveTab":
            return action.payload;
        default:
            return state;
    }
};

export default tabReducer;
